import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("actionRegistrationDate"),
            field: "creationDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("actionType"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("state"),
            field: "statusString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("attachment"),
            field: "completeFilePath",
            filter: "agTextColumnFilter",
            cellRenderer: "ExternalFileRenderer"
        }
    },
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("actionDescription"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("reminderDateForAlert"),
            field: "reminderDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("referenceEmployee"),
            field: "referenceEmployeeName",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.actions],
        config: {
            headerName: getLocalizedString("referenceGroup"),
            field: "referenceGroupName",
            filter: "agSetColumnFilter",
        }
    },
]